import FieldsBrookStreamData from "../../../../src/components/fields-brook-stream-data.js";
import * as React from 'react';
export default {
  FieldsBrookStreamData,
  React
};